import { Clipboard } from '@angular/cdk/clipboard';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DashboardEstimationColumnEnum, Estimation, EstimationProgressEnum, SelectableEstimation } from '../../models/estimation.model';
import { Router } from '@angular/router';

@Component({
  selector: 'app-dashboard-estimation-table',
  templateUrl: './dashboard-estimation-table.component.html',
  styleUrl: './dashboard-estimation-table.component.scss'
})
export class DashboardEstimationTableComponent {
  @Input() estimationTableData: Estimation[] = [];
  @Input() totalEstimations: number = 0;
  @Input() usersInEstimations: any = {
    userWhoAuthorizes: [],
    userWhoBuys: [],
    userWhoReviews: [],
    userWhoRequests: [],
  };
  @Output() highlightEstimation = new EventEmitter<{
    estimation: Estimation;
    tableIndex: number;
  }>();
  currentTab: number = 0;
  estimationTabsList: any[] = ['Todas', 'Iniciado', 'Por revisar', 'Por autorizar', 'Por enviar a pagos', 'Enviado a pagos', 'En proceso de pago', 'Pagada', 'Rechazada', 'Cancelada'];
  estimationTableDataBackup: Estimation[] = [];
  loading: boolean = false;
  pageSize: number = 10;
  openedNotes = new Set<number>();
  extraActionButtonText: string = 'Ir a mis estimaciones';
  paginatorItems: number[] = [];
  itemsPerPage: number[] = [10, 20, 30];
  currentPage: number = 1;
  public estimationColumnsEnum = DashboardEstimationColumnEnum;
  currentRowElements: Partial<SelectableEstimation>[] = [];

  estimationColumnsList = [
    {
      title: 'Proyecto',
      name: 'project',
      width: '350px',
      align: 'left',
    },
    {
      title: 'Proveedor',
      name: 'providerName',
      width: '250px',
      align: 'left',
    },
    {
      title: 'Folio',
      name: 'estimationFolio',
      width: '70px',
      align: 'left',
    },
    {
      title: 'Descripción',
      name: 'estimationDescription',
      width: '350px',
      align: 'left',
    },
    {
      title: 'Fecha de estimación',
      name: 'estimationApplicationDate',
      width: '230px',
      align: 'left',
    },
    {
      title: 'Creador',
      name: 'userWhoRequests',
      width: '350px',
      align: 'left',
    },
    {
      title: 'Importe',
      name: 'totalCost',
      width: '200px',
      align: 'center',
    },
    {
      title: 'Prioridad',
      name: 'priority',
      width: '140px',
      align: 'center',
    },
    {
      title: 'Progreso Actual',
      name: 'estimationProgress',
      width: '200px',
      align: 'center',
    }
  ];

  constructor(private router: Router,  private clipboard: Clipboard) {}

  ngOnChanges(): void {
    this.paginatorItems =
      this.totalEstimations / this.pageSize
        ? [
            ...Array(Math.ceil(this.totalEstimations / this.pageSize)).keys(),
          ].map((x) => x + 1)
        : [];
    this.estimationTableDataBackup = [...this.estimationTableData];
    this.currentRowElements = this.estimationTableData.map((x) => ({
      estimationId: x.estimationId,
      isFolioTooltipVisible: false
    }));
  }

  onChangeEstimationTab(tab: number): void {
    this.currentTab = tab;
    switch (tab) {
      case 0:
        // Todas
        this.estimationTableData = [...this.estimationTableDataBackup];
        break;
      case 1:
        // Iniciado
        this.estimationTableData = this.estimationTableDataBackup
          .filter((x) => x.estimationProgress?.id === EstimationProgressEnum.Iniciado);
        break;
      case 2:
        // Por revisar
        this.estimationTableData = this.estimationTableDataBackup
          .filter((x) => x.estimationProgress?.id === EstimationProgressEnum['Por revisar']);
        break;
      case 3:
        // Por autorizar
        this.estimationTableData = this.estimationTableDataBackup
          .filter((x) => x.estimationProgress?.id === EstimationProgressEnum['Por autorizar']);
        break;
      case 4:
        // Por enviar a pagos
        this.estimationTableData = this.estimationTableDataBackup
          .filter((x) => x.estimationProgress?.id === EstimationProgressEnum['Por enviar a pagos']);
        break;
      case 5:
        // Enviado a pagos
        this.estimationTableData = this.estimationTableDataBackup
          .filter((x) => x.estimationProgress?.id === EstimationProgressEnum['Enviado a pagos']);
        break;
      case 6:
        // En proceso de pago
        this.estimationTableData = this.estimationTableDataBackup
          .filter((x) => x.estimationProgress?.id === EstimationProgressEnum['En proceso de pago']);
        break;
      case 7:
        // Pagada
        this.estimationTableData = this.estimationTableDataBackup
        .filter((x) => x.estimationProgress?.id === EstimationProgressEnum.Pagada);
        break;
      case 8:
        // Rechazada
        this.estimationTableData = this.estimationTableDataBackup
          .filter((x) => x.estimationProgress?.id === EstimationProgressEnum.Rechazada);
        break;
      case 9:
        // Cancelada
        this.estimationTableData = this.estimationTableDataBackup
          .filter((x) => x.estimationProgress?.id === EstimationProgressEnum.Cancelada);
        break;
      default:
        this.estimationTableData = [...this.estimationTableDataBackup];
        break;
    }
  }

  onCopyToClipboard(value: string, index: number, $event: any) {
    $event.stopPropagation();
    $event.preventDefault();
    if (value === '') return
    this.clipboard.copy(value);
    this.currentRowElements[index].isFolioTooltipVisible = true;

    setTimeout(() => {
      this.currentRowElements[index].isFolioTooltipVisible = false;
    }, 1000);
  }

  onHighlightEstimation(
    data: Estimation,
    isHighlighted: boolean,
    tableIndex: number,
    $event: any
  ) {
    $event.stopPropagation();
    $event.preventDefault();
    this.highlightEstimation.emit({
      estimation: { ...data, isAuthorized: isHighlighted },
      tableIndex: tableIndex,
    });
  }
  
  onSelectNote(id: number) {
    this.openedNotes.has(id) ? this.openedNotes.delete(id) : this.openedNotes.add(id);
  }

  onCloseNote(id: number) {
    this.openedNotes.delete(id);
  }

  onGoToEstimationDetails(estimation: Estimation) {
    this.router.navigate([
      `estimaciones/${estimation.project.projectId ?? 'all'}/estimacion/${estimation.estimationId}`,
    ]);
  }

}
